// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3yJ81","consentsList":"PatientConsents_consentsList__2aiC-","consentsListEmpty":"PatientConsents_consentsListEmpty__330UB"};